import { formatPriorAuthBlock } from '../referral-response/getNotesFormatting';

/**
 * Formats a PA status update entry to be appended to existing referral notes.
 */
export function formatPaStatusNote(status: string): string {
  return formatPriorAuthBlock({
    priorAuthStatus: status,
    updatedAt: new Date().toISOString(),
  });
}
